import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService } from '../../shared/services';
import { ApiMode } from '../../utils/enums';
import { OfflineApiService } from '../../shared/services/offlineApi.service';
import { AppConstants } from '../../utils/appConstants.class';
import { OptimisationMachineSelectorFactoryService } from './optimisationmachineselector-plugin-factory.service';

@Injectable()
export class OptmizationMachineSelectorPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    offlineApi: OfflineApiService,
    private optimizationFactory: OptimisationMachineSelectorFactoryService
  ) {
    super(apiService, dataService, offlineApi, optimizationFactory);
  }

  public updateMachines(inspectionId: string, pluginId: string, machines: any): Observable<any> {
    return this._updateMachines(inspectionId, pluginId, machines).pipe(
      map((inspectedObjects: any) => {
        this.dataService.updateInspectedData(inspectionId, inspectedObjects);
        return this.dataService.updatePluginConfig(inspectionId, pluginId, { Machines: machines });
      })
    );
  }

  public getModels(): Observable<any> {
    const url = '/plugins/optmachineselector/models';
    return this.offlineApi.getWithMode(url, ApiMode.Offline, AppConstants.INDEXEDDB_TABLES.models);
  }

  public updateCategories(inspectionId: string, data: any) {
    const url = '/models/' + inspectionId + '/categories';
    return this.apiService.post(url, data).pipe(
      map((categories: any) => {
        this.dataService.updateCategories(inspectionId, categories);
      })
    ) as any;
  }

  private _updateMachines(inspectionId: string, pluginId: string, machines: any): Observable<any> {
    return this.optimizationFactory.updateMachines(inspectionId, pluginId, machines).pipe(
      flatMap((res) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(res.data);
        }
        return this.apiService.post(res.plugin.postServerUrl, res.plugin.config);
      })
    );
  }
}
